import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import hashPassword from "../components/HashPassword";
import emailjs from '@emailjs/browser';
import { form } from "motion/react-client";

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

function Signup() {
    const apiKey = process.env.REACT_APP_API_KEY;
    const windowSize = useWindowSize();
    const [firstname, setFirstName] = useState("");
    const [lastname, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [encodedPassword, setEncodedPassword] = useState("");
    const navigate = useNavigate();
    const formRef = useRef(null);

    const handleFirstNameChange = (e) => {
        setFirstName(e.target.value);
    };

    const handleLastNameChange = (e) => {
        setLastName(e.target.value);
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
    };

    function verticalSpacer(height) {
        return <div style={{ height: height }}></div>;
    }

    function encodePassword(password) {
        return hashPassword(btoa(password));
    }

    function isValidEmail(email) {
        //regular expression pattern for basic email validation
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    }

    // function sendEmail() {
    //     emailjs.send(
    //         "service_g4gyqrh",
    //         "template_rwiogdg",
    //         {
    //             name: `${firstname} ${lastname}`,
    //             email: email,
    //             message: "New user registered", 
    //         },
    //         {
    //             publicKey: "EjnhASYsdI6zI-c_I",
    //         }
    //         ).then(
    //         () => console.log("SUCCESS!"),
    //         (error) => console.log("FAILED...", error.text)
    //     );

    // };

    function sendEmail( subject, message){
    const payload = {
            api_key: apiKey,
            user_email: email,
            subject: subject, //"Password Reset Confirmation",
            message: message
            
        };

            try {
                fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/sendEmail`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`Error: ${response.statusText}`);
                    }
                    return response.json();
                })
                .then((data) => {
                    //console.log(data);
                    //alert("Password Reset successful! You can now log in.");
                    // navigate('/CustomerDashboardPage');
                })
                .catch((error) => {
                    console.error("email sent failed:", error);
                    //alert("email sent failed, please try again.");
                });
            } catch (error) {
                console.error("email sent failed:", error);
                //alert("email sent, please try again.");
            }

  }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            alert("Passwords do not match!");
            return;
        }

        if (password.length < 4) {
            alert("Password must be at least 4 characters long!");
            return;
        }

        if (!isValidEmail(email)) {
            alert("Please enter a valid email address!");
            return;
        }


        const payload = {
            api_key: apiKey,
            user_email: email,
            user_password: encodePassword(password),
            user_first_name: firstname || null,
            user_last_name: lastname || null,
        };
        // console.log("Payload to be sent:", payload);
        

        

            try {
                fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/registerAccount`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`Error: ${response.statusText}`);
                    }
                    return response.json();
                })
                .then((data) => {
                    // console.log("Registration successful:", data);
                    
                    const subject = `Welcome to Carmel House Supply, ${firstname}!`
                    const message = `Welcome to the Carmel House Supply family! We're excited to have you on board.

Your account has been successfully created, and you're now ready to explore all the great products we offer.

If you have any questions or need help getting started, our support team is just an email away at support@carmelhousesupply.com. We're here to assist you every step of the way!

Best regards,`
                    sendEmail(subject, message)
                    alert("Registration successful! You can now log in.");
                    navigate('/CustomerDashboardPage');
                })
                .catch((error) => {
                    console.error("Registration failed:", error);
                    alert("Registration failed, please try again.");
                });
            } catch (error) {
                console.error("Registration failed:", error);
                alert("Registration failed, please try again.");
            }
    };

    const handleCancel = () => {
        navigate('/');
    };

    return (
        <div>
        <div className="register-container" align="center">
            <h2 className="registerTitle">Register</h2>
            <br />
            <div className="register-page">
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        {/* <label htmlFor="firstname" className="form-label">First Name</label> */}
                        <input placeholder="First Name" type="text" id="firstname" value={firstname} onChange={handleFirstNameChange} />
                    </div>
                    <div className="form-group">
                        {/* <label htmlFor="lastname" className="form-label">Last Name</label> */}
                        <input placeholder="Last Name" type="text" id="lastname" value={lastname} onChange={handleLastNameChange} />
                    </div>
                    <div className="form-group">
                        {/* <label htmlFor="email" className="form-label">Email</label> */}
                        <input placeholder="Email" type="email" id="email" value={email} onChange={handleEmailChange} required />
                    </div>
                    <div className="form-group">
                        {/* <label htmlFor="password" className="form-label">Password</label> */}
                        <input placeholder="Password" type="password" id="password" value={password} onChange={handlePasswordChange} required />
                    </div>
                    <div className="form-group">
                        {/* <label htmlFor="confirmPassword" className="form-label">Confirm Password</label> */}
                        <input placeholder="Confirm Password" type="password" id="confirmPassword" value={confirmPassword} onChange={handleConfirmPasswordChange} required />
                    </div>
                    
                    <button className="registersubmitbutton" type="submit">Register</button> <br />
                    <button className="cancelregistrationbutton" type="button" onClick={handleCancel}> Cancel</button>
                </form>
            </div>
        </div>
        {verticalSpacer((windowSize.width * 0.35) + (windowSize.height * 0.2))}
        </div>
    );
}

export default Signup;